import React from "react";
import IocListManager from "./IocListManager";

export default function WhitelistedIocs() {
  return (
    <IocListManager
      apiPath="/api/admin/whitelist"
      variant="safe"
      title="Whitelisted IoCs"
      subtitle="Trusted senders, domains, IPs, hostnames, and URLs that PhishMatrix should treat as safe. Active entries suppress malicious flags during analysis."
      valuePlaceholder="e.g. accenture.com or 10.0.0.5 or notifications@accenture.com"
      notesPlaceholder="Why is this whitelisted?"
      emptyText="No whitelist entries yet. Add the first one above."
      forbiddenText="This section is only available to administrators and contributors."
    />
  );
}
